import React from "react";

import { Dialog, InfoSmIcon } from "@packages/ds";
import { useIntl } from "react-intl";
import styled from "styled-components";

export const Popover = () => {
  const intl = useIntl();
  const lastYear = new Date().getFullYear() - 1;

  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <GraphIconWrapper>
          <InfoSmIcon fill="var(--mode-vector-neutral-default)" />
        </GraphIconWrapper>
      </Dialog.Trigger>
      <PopoverContent>
        <h1>
          {intl.formatMessage({
            id: "carbon.emissions.popover.title",
            defaultMessage: "Data availability"
          })}
        </h1>
        <p>
          {intl.formatMessage(
            {
              id: "carbon.emissions.popover.content",
              defaultMessage:
                "{year} emissions data excludes projects hosted in the Orange (FR-1) and OVHcloud (FR-3) regions."
            },
            { year: lastYear }
          )}
        </p>
      </PopoverContent>
    </Dialog.Root>
  );
};

const PopoverContent = styled(Dialog.Content)`
  font-family: var(--ff-sans, "Open Sans");
  font-size: var(--fs-s, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: var(--mode-text-neutral-default-weak);
  text-align: left;
  transform-origin: top right;
  position: absolute;
  right: -20px;
  left: auto;

  h1 {
    font-size: var(--fs-s, 14px);
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 0;
  }
  p {
    margin-top: 0;
  }
`;

const GraphIconWrapper = styled.span`
  margin-left: 6px;
  position: relative;
  top: 1px;
  cursor: pointer;
`;
